import {
    LinkedAccountTypesEnum,
    LinkedAccountStatusesEnum,
    LinkedAccountModel,
    LinkedAccountFilterModel
} from '@spa/api';

import {FilterControl, Helper} from '../../app/shared/classes';
import {ComponentTypesEnum} from '../../app/shared/enums/common';
import {BaseControl, SelectControl} from '../../app/shared/classes/controls';
import {ReportTableColumn, ReportTableConfigInterface, ReportTableData} from '../../app/shared/components/report-table';
import {Validators} from '@angular/forms';
import {InArrayValidator} from '@spa/validators';

export const BankAccountIdSelector = 'bankAccountId';
export const PanelBankAccountsStorageId = 'PanelBankAccountsComponent';

export const PanelBankAccountsFilterControls = (): FilterControl[] => {
    return [
        new FilterControl({
            name: LinkedAccountFilterModel.getStatusSelector(),
            placeholder: 'Status',
            controls: [
                new SelectControl({
                    name: LinkedAccountFilterModel.getStatusSelector(),
                    value: LinkedAccountStatusesEnum.All,
                    placeholder: 'Status',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getBankAccountStatusName(LinkedAccountStatusesEnum.All),
                            value: LinkedAccountStatusesEnum.All
                        },
                        {
                            label: Helper.textsHelper().getBankAccountStatusName(LinkedAccountStatusesEnum.New),
                            value: LinkedAccountStatusesEnum.New
                        },
                        {
                            label: Helper.textsHelper().getBankAccountStatusName(LinkedAccountStatusesEnum.Active),
                            value: LinkedAccountStatusesEnum.Active
                        },
                        {
                            label: Helper.textsHelper().getBankAccountStatusName(LinkedAccountStatusesEnum.Inactive),
                            value: LinkedAccountStatusesEnum.Inactive
                        }
                    ]
                }),
            ],
            sortIndex: 1
        }),
        new FilterControl({
            name: LinkedAccountFilterModel.getOwnerNameSelector(),
            placeholder: 'Client Name',
            controls: [
                new BaseControl({
                    name: LinkedAccountFilterModel.getOwnerNameSelector(),
                    value: null,
                    placeholder: 'Client Name',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 2
        }),
        new FilterControl({
            name: LinkedAccountFilterModel.getLinkedAccountTypeSelector(),
            placeholder: 'Account',
            controls: [
                new SelectControl({
                    name: LinkedAccountFilterModel.getLinkedAccountTypeSelector(),
                    value: null,
                    placeholder: 'Account Type',
                    validators: [
                        Validators.required,
                        InArrayValidator([
                            LinkedAccountTypesEnum.Iban,
                            LinkedAccountTypesEnum.Account,
                            LinkedAccountTypesEnum.SortCode,
                            LinkedAccountTypesEnum.CryptoWallet
                        ])
                    ],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getBankAccountTypeName(LinkedAccountTypesEnum.Iban, true),
                            value: LinkedAccountTypesEnum.Iban
                        },
                        {
                            label: Helper.textsHelper().getBankAccountTypeName(LinkedAccountTypesEnum.Account, true),
                            value: LinkedAccountTypesEnum.Account
                        },
                        {
                            label: Helper.textsHelper().getBankAccountTypeName(LinkedAccountTypesEnum.SortCode, true),
                            value: LinkedAccountTypesEnum.SortCode
                        },
                        {
                            label: Helper.textsHelper().getBankAccountTypeName(LinkedAccountTypesEnum.CryptoWallet, true),
                            value: LinkedAccountTypesEnum.CryptoWallet
                        }
                    ]
                }),
                new BaseControl({
                    name: LinkedAccountFilterModel.getAccountSelector(),
                    value: null,
                    placeholder: 'Account',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 3
        }),
        new FilterControl({
            name: LinkedAccountFilterModel.getCreateDateSelector(),
            placeholder: 'Created Date',
            controls: [
                new BaseControl({
                    name: LinkedAccountFilterModel.getCreateDateFromSelector(),
                    value: null,
                    placeholder: 'Created Date From',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new BaseControl({
                    name: LinkedAccountFilterModel.getCreateDateToSelector(),
                    value: null,
                    placeholder: 'Created Date To',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                }),
            ],
            sortIndex: 4
        })
    ];
};

export const PanelBankAccountsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<number>({
            colId: LinkedAccountModel.getStatusSelector(),
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: LinkedAccountModel.getOwnerNameSelector(),
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: LinkedAccountModel.getAccountTypeSelector(),
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: LinkedAccountModel.getAccountSelector(),
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: LinkedAccountModel.getCreateDateSelector(),
            value: null,
            hidden: false

        })
    ];
};

export const PanelBankAccountsDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Status',
                selector: LinkedAccountModel.getStatusSelector()
            }),
            new ReportTableColumn({
                label: 'Client',
                selector: LinkedAccountModel.getOwnerNameSelector()
            }),
            new ReportTableColumn({
                label: 'Account Type',
                selector: LinkedAccountModel.getAccountTypeSelector()
            }),
            new ReportTableColumn({
                label: 'Account',
                selector: LinkedAccountModel.getAccountSelector()
            }),
            new ReportTableColumn({
                label: 'Created Date',
                selector: LinkedAccountModel.getCreateDateSelector()
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: false
    };
};

